import { useState } from "react";
import searchImage from "../assets/image/search_black_24dp.svg";
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/prime.css";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import opacity from "react-element-popper/animations/opacity";

export default function Top(props) {
  const flightType = [
    {
      id: "out-flight",
      name: "پرواز داخلی",
    },
    {
      id: "in-flight",
      name: "پرواز خارجی",
    },
  ];

  const theWay = [
    {
      id: "oneway",
      name: "یک طرفه",
    },
    {
      id: "twoway",
      name: "رفت و برگشت",
    },
  ];

  return (
    <div className="p-5 flight-card d-flex justify-content-end">
      <div className="card col-md-9 col-lg-8 col-12 round ">
        <div className="card-header bg-transparent" style={{ border: "none" }}>
          <ul className="nav nav-pills m-1" id="pills-tab" role="tablist">
            {flightType.map((type, index) => (
              <li className="nav-item" role="presentation" key={index}>
                <button
                  className={`btn btn-outline-secondary round p-3 flightBtn text-dark size3 me-2 ${
                    index == 0 ? "active" : ""
                  }`}
                  id={`${type.id}-id-tab`}
                  data-bs-toggle="pill"
                  data-bs-target={`#${type.id}-id`}
                  type="button"
                  role="tab"
                  aria-controls={`${type.id}-id`}
                  aria-selected="true"
                >
                  {type.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="card-body">
          <div className="tab-content" id="pills-tabContent">
            {flightType.map((type, index) => (
              <div
                className={`tab-pane fade show ${index == 0 ? "active" : ""}`}
                id={`${type.id}-id`}
                role="tabpanel"
                aria-labelledby={`${type.id}-id-tab`}
                key={index}
              >
                <ul
                  className="nav nav-pills mb-3 border-top"
                  id="pills-tab"
                  role="tablist"
                >
                  {theWay.map((way, index1) => (
                    <li className="nav-item" role="presentation">
                      <button
                        className={`wayBtn shadowBtn border-0 btn ${
                          index1 == 0 ? "active" : ""
                        } size2 way-color`}
                        id={`${type.id}-${way.id}-id-tab`}
                        data-bs-toggle="pill"
                        data-bs-target={`#${type.id}-${way.id}-id`}
                        type="button"
                        role="tab"
                        aria-controls={`${type.id}-${way.id}-id`}
                        aria-selected="true"
                        key={index}
                      >
                        {way.name}
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="tab-content" id="pills-tabContent">
                  {theWay.map((way, index1) => (
                    <div
                      className={`tab-pane fade show ${
                        index1 == 0 ? "active" : ""
                      }`}
                      id={`${type.id}-${way.id}-id`}
                      role="tabpanel"
                      aria-labelledby={`${type.id}-${way.id}-id-tab`}
                      key={index1}
                    >
                      <div className="d-flex flex-column">
                        <div className="row justify-content-evenly px-2">
                          <div className="col-12 col-md-6 col-lg-3">
                            <select className="form-select btn-flight btn button-background button-padding round button-height m-2 shadowBtn">
                              <option>از کجا؟</option>
                              <option className="font-regular">شیراز</option>
                              <option className="font-regular">مشهد</option>
                              <option className="font-regular">کیش</option>
                            </select>
                          </div>

                          <div className="col-12 col-md-6 col-lg-3">
                            <select className="form-select btn-flight btn button-background button-padding round button-height m-2 shadowBtn">
                              <option>به کجا؟</option>
                              <option className="font-regular">شیراز</option>
                              <option className="font-regular">مشهد</option>
                              <option className="font-regular">کیش</option>
                            </select>
                          </div>

                          <div className="col-12 col-md-6 col-lg-3">
                            <DatePicker
                              className=""
                              calendar={persian}
                              id=""
                              locale={persian_fa}
                              placeholder="تاریخ رفت"
                              animations={[opacity()]}
                              style={{
                                width: "100%",
                                textAlign: "center",
                                boxSizing: "border-box",
                                height: "26px",
                                padding: "20px 8px",
                              }}
                              containerStyle={{ width: "100%" }}
                            />
                          </div>

                          {index1 == 1 ? (
                            <div className="col-12 col-md-6 col-lg-3">
                              <DatePicker
                                className=""
                                calendar={persian}
                                id=""
                                locale={persian_fa}
                                placeholder="تاریخ برگشت"
                                animations={[opacity()]}
                                style={{
                                  width: "100%",
                                  textAlign: "center",
                                  boxSizing: "border-box",
                                  height: "26px",
                                  padding: "20px 10px",
                                }}
                                containerStyle={{ width: "100%" }}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="col-12 col-md-6 col-lg-3">
                            <button
                              className="btn-flight btn button-background button-padding round button-height m-2 shadowBtn"
                              style={{ width: "100%" }}
                            >
                              <p className=" m-0" style={{ fontSize: "10px" }}>
                                مسافران
                              </p>
                              <p className="m-0">1مسافر</p>
                            </button>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <button className="col-12 col-sm-2 btn-search btn button-background button-padding round bg-warning ms-lg-auto shadow mt-1 button-height">
                            <img src={searchImage} alt="" />
                            جستجو
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
